import type { FC, ReactNode } from "react";
import styled from "styled-components";
import {
  Button,
  ButtonExternal,
  ItemText,
} from "../../NavigationBar/SidebarItemElements";
import { ProfileItemButtonContainer } from "./ProfileElements";

export const StyledItemText = styled(ItemText)`
  margin: 0;
`;

export const StyledButton = styled(Button)`
  padding: 0 0 0 16px;
  gap: 10px;
`;

export const StyledExternalButton = styled(ButtonExternal)`
  padding: 0 0 0 16px;
  gap: 10px;
`;

type ProfileListItemProps = {
  text: string;
  to: string;
  external?: boolean;
  hyperlink?: boolean;
  icon?: ReactNode;
};
export const ProfileListItem: FC<ProfileListItemProps> = ({
  text,
  to,
  external,
  hyperlink,
  icon,
}) => (
  <ProfileItemButtonContainer isActive={false}>
    {external || hyperlink ? (
      <StyledExternalButton
        href={to}
        target={external ? "_blank" : "_self"}
        $isActive={false}
      >
        {icon}
        <StyledItemText>{text}</StyledItemText>
      </StyledExternalButton>
    ) : (
      <StyledButton to={to} $isActive={false}>
        {icon}
        <StyledItemText>{text}</StyledItemText>
      </StyledButton>
    )}
  </ProfileItemButtonContainer>
);
